import script from "./TagsListMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagsListMobile.vue?vue&type=script&lang=ts&setup=true"

import "./TagsListMobile.vue?vue&type=style&index=0&id=20456539&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20456539"]])

export default __exports__